import React from "react";
import {
  ArrayInput,
  Button,
  ReferenceInput,
  SelectInput,
  SimpleFormIterator,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AddIcon from "@mui/icons-material/Add";
import { formatStudentOption } from "../../utils";
import { settings } from "app";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const AssignStudentsDialog = ({ cycleId, slotsChoices, planId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      cycleId,
      assignments: data.assignments,
    };
    await dataProvider.customRequest(graduationRequests.assignStudentsToIndividualCycle(cycleId), payload, "PUT");
    refresh();
    notify("Успешно добавяне на студент към стартов часови интервал", { type: "success" });
  };
  return (
    <FormModal
      titleContent={"Добави студент към часови интервал"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добави студенти"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ mt: 2 }}
        />
      }
    >
      <ArrayInput
        source="assignments"
        label=" "
        defaultValue={[{}]}
      >
        <SimpleFormIterator
          disableReordering
          disableClear
          sx={settings.style.iteratorWithoutGap}
        >
          <ReferenceInput
            source="studentEducationId"
            reference={graduationRequests.getInternshipStudentsSelect()}
            filter={{ planId }}
          >
            <SelectInput
              source="studentEducationId"
              optionValue="studentEducationId"
              optionText={formatStudentOption()}
              emptyText={false}
              label="Студент"
            />
          </ReferenceInput>
          <SelectInput
            source="startSlotId"
            label="Стартира с часови интервал"
            choices={slotsChoices}
            emptyText={false}
            optionText={rec => `${rec.startTime} - ${rec.endTime}`}
            optionValue="id"
          />
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default AssignStudentsDialog;
